<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  class?: string;
}>();
</script>

<template>
  <div class="divider" :class="props.class"></div>
</template>
